import { useInView } from "../../hooks/useInView";

export function AnimatedBlock({ children, className = "", delay = 0, as: Tag = "div" }) {
  const [ref, inView] = useInView(0.1);
  return (
    <Tag ref={ref} className={className} style={{ opacity: inView ? 1 : 0, transform: inView ? "translateY(0px)" : "translateY(36px)", transition: `opacity 0.6s ease ${delay}ms, transform 0.6s cubic-bezier(0.22,1,0.36,1) ${delay}ms` }}>
      {children}
    </Tag>
  );
}
